var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTitle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    zoomAndPan: "magnify",
    viewBox: "0 0 282.96 56.999996",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "4dc42db625"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5738a5310"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.242188 L 282.921875 11.242188 L 282.921875 46.488281 L 0 46.488281 Z M 0 11.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec5f41d8f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.621094 11.242188 L 265.800781 11.242188 C 275.535156 11.242188 283.425781 19.132812 283.425781 28.867188 C 283.425781 38.597656 275.535156 46.488281 265.800781 46.488281 L 17.621094 46.488281 C 7.890625 46.488281 0 38.597656 0 28.867188 C 0 19.132812 7.890625 11.242188 17.621094 11.242188 Z M 17.621094 11.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00476074,
    gradientTransform: "matrix(0.137677, 0, 0, 0.137677, -0.000655445, 11.243353)",
    y1: 128,
    x2: 2054.959103,
    gradientUnits: "userSpaceOnUse",
    y2: 128,
    id: "f47a66dc24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 87.098694%, 34.899902%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.981201%, 34.881592%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.746216%, 34.844971%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.509705%, 34.806824%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.274719%, 34.770203%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 86.039734%, 34.733582%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.803223%, 34.69696%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.568237%, 34.660339%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.333252%, 34.623718%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 85.096741%, 34.587097%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.861755%, 34.550476%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.625244%, 34.513855%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.390259%, 34.477234%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.155273%, 34.440613%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.918762%, 34.403992%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.683777%, 34.367371%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.448792%, 34.33075%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 83.21228%, 34.294128%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.977295%, 34.257507%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.74231%, 34.220886%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.505798%, 34.184265%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.270813%, 34.147644%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 82.035828%, 34.111023%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.799316%, 34.074402%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.564331%, 34.037781%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.329346%, 34.00116%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 81.092834%, 33.964539%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.857849%, 33.927917%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.622864%, 33.891296%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.386353%, 33.854675%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 80.151367%, 33.818054%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.914856%, 33.781433%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.679871%, 33.744812%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.444885%, 33.708191%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 79.208374%, 33.67157%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.973389%, 33.634949%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.738403%, 33.598328%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.501892%, 33.561707%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.266907%, 33.525085%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 78.031921%, 33.488464%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.79541%, 33.451843%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.560425%, 33.415222%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.325439%, 33.378601%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 77.088928%, 33.34198%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.853943%, 33.305359%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.618958%, 33.268738%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.382446%, 33.232117%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 76.147461%, 33.195496%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.912476%, 33.158875%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.675964%, 33.122253%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.440979%, 33.084106%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 75.205994%, 33.047485%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.969482%, 33.010864%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.734497%, 32.974243%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.497986%, 32.937622%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.263%, 32.901001%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 74.028015%, 32.86438%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.791504%, 32.827759%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.556519%, 32.791138%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.321533%, 32.754517%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 73.085022%, 32.717896%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.850037%, 32.681274%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.615051%, 32.644653%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.37854%, 32.608032%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 72.143555%, 32.571411%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.908569%, 32.53479%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.672058%, 32.498169%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.437073%, 32.461548%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 71.202087%, 32.424927%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.965576%, 32.388306%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.730591%, 32.351685%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.495605%, 32.315063%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.259094%, 32.278442%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 70.024109%, 32.241821%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.789124%, 32.2052%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.552612%, 32.168579%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.317627%, 32.131958%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 69.081116%, 32.095337%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.84613%, 32.058716%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.611145%, 32.022095%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.374634%, 31.985474%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 68.139648%, 31.948853%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.904663%, 31.912231%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.668152%, 31.87561%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.433167%, 31.838989%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 67.198181%, 31.802368%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.96167%, 31.765747%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.726685%, 31.729126%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.491699%, 31.692505%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.255188%, 31.655884%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 66.020203%, 31.619263%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.785217%, 31.582642%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.548706%, 31.546021%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.313721%, 31.509399%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 65.078735%, 31.472778%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.842224%, 31.436157%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.607239%, 31.399536%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.370728%, 31.362915%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 64.135742%, 31.324768%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.900757%, 31.288147%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.664246%, 31.251526%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.42926%, 31.214905%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 63.194275%, 31.178284%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.957764%, 31.141663%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.722778%, 31.105042%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.487793%, 31.06842%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.251282%, 31.031799%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 62.016296%, 30.995178%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.781311%, 30.958557%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.5448%, 30.921936%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.309814%, 30.885315%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 61.074829%, 30.848694%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.838318%, 30.812073%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.603333%, 30.775452%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.368347%, 30.738831%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 60.131836%, 30.702209%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.896851%, 30.665588%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.661865%, 30.628967%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.425354%, 30.592346%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 59.190369%, 30.555725%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.953857%, 30.519104%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.718872%, 30.482483%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.483887%, 30.445862%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.247375%, 30.409241%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 58.01239%, 30.37262%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.777405%, 30.335999%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.540894%, 30.299377%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.305908%, 30.262756%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 57.070923%, 30.226135%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fc05b0f44f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4dc42db625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5a6d05148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 0.242188 L 33 0.242188 L 33 35.488281 L 0.804688 35.488281 Z M 0.804688 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7c34d23eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 0.242188 L 59 0.242188 L 59 35.488281 L 27 35.488281 Z M 27 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e55545a719"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 0.242188 L 86 0.242188 L 86 35.488281 L 54 35.488281 Z M 54 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d219b7e0a1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 87,
    y: 0,
    height: 36
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aa931e8b25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4dc42db625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.296,
    width: 339.552,
    fill: "#000000",
    y: -5.7,
    height: 68.399996,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "896e46d41e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.976562 0.242188 L 33 0.242188 L 33 35.488281 L 0.976562 35.488281 Z M 0.976562 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "babf53ccda"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 0.242188 L 60 0.242188 L 60 35.488281 L 27 35.488281 Z M 27 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02e4e0e5f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 0.242188 L 86.464844 0.242188 L 86.464844 35.488281 L 54 35.488281 Z M 54 0.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "062d85b7a0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 87,
    y: 0,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5738a5310)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec5f41d8f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f47a66dc24)",
    d: "M 0 11.242188 L 0 46.488281 L 282.921875 46.488281 L 282.921875 11.242188 Z M 0 11.242188 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fc05b0f44f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 172, 11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d219b7e0a1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5a6d05148)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 32.019531 17.867188 L 25.199219 11.011719 L 25.164062 11.046875 L 14.4375 0.285156 L 0.804688 0.363281 L 18.34375 17.867188 L 0.804688 35.371094 L 14.4375 35.445312 L 25.164062 24.683594 L 25.199219 24.722656 Z M 32.019531 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7c34d23eb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 58.984375 17.867188 L 52.164062 11.011719 L 52.128906 11.046875 L 41.402344 0.285156 L 27.804688 0.363281 L 45.308594 17.867188 L 27.804688 35.371094 L 41.402344 35.445312 L 52.128906 24.683594 L 52.164062 24.722656 Z M 58.984375 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e55545a719)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 85.984375 17.867188 L 79.128906 11.011719 L 79.128906 11.046875 L 68.40625 0.285156 L 54.769531 0.363281 L 72.273438 17.867188 L 54.769531 35.371094 L 68.40625 35.445312 L 79.128906 24.683594 L 79.128906 24.722656 L 85.984375 17.867188 L 85.949219 17.867188 Z M 85.984375 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa931e8b25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48, 11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#062d85b7a0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#896e46d41e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 32.191406 17.867188 L 25.375 11.011719 L 25.335938 11.046875 L 14.613281 0.285156 L 0.976562 0.363281 L 18.519531 17.867188 L 0.976562 35.371094 L 14.613281 35.445312 L 25.335938 24.683594 L 25.375 24.722656 Z M 32.191406 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#babf53ccda)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 59.15625 17.867188 L 52.339844 11.011719 L 52.300781 11.046875 L 41.578125 0.285156 L 27.980469 0.363281 L 45.484375 17.867188 L 27.980469 35.371094 L 41.578125 35.445312 L 52.300781 24.683594 L 52.339844 24.722656 Z M 59.15625 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02e4e0e5f2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5757",
    d: "M 86.160156 17.867188 L 79.304688 11.011719 L 79.304688 11.046875 L 68.578125 0.285156 L 54.945312 0.363281 L 72.449219 17.867188 L 54.945312 35.371094 L 68.578125 35.445312 L 79.304688 24.683594 L 79.304688 24.722656 L 86.160156 17.867188 L 86.121094 17.867188 Z M 86.160156 17.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTitle4);
export default __webpack_public_path__ + "static/media/bg-title_4.7f0dc3f1565926cdd7b5120c3dfdddd4.svg";
export { ForwardRef as ReactComponent };